import React from 'react';
import { Button, Typography } from 'antd';
import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import forceReloadIcon from '@/public/icons/force-reload.svg';
import { LOCAL_STORAGE } from '@/shared/constants/localStorage';
import { SESSION_STORAGE } from '@/shared/constants/sessionStorage';
import SolgariLogo from '@/public/images/solgari-logo.png';
import { SipJs } from '@/services/sip-js.service';
import { EPresenceStatusApi } from '@/shared/enums/presence.enum';
import './ForceReload.scss';

const { Paragraph } = Typography;
type ForceReloadMode = 'show-content';

export interface ForceReloadProps {
  sendWarning: any;
  className?: string;
  mode?: ForceReloadMode;
}

export const ForceReload = ({
  sendWarning,
  className,
  mode,
}: ForceReloadProps) => {
  const resetLocalState = async () => {
    await SipJs.pushNotification(EPresenceStatusApi.AVAILABLE, true);
    localStorage.removeItem(LOCAL_STORAGE.LS_MANUAL_PRESENCE);
    localStorage.removeItem(LOCAL_STORAGE.LS_TAB_ID_KEY);
    localStorage.removeItem(LOCAL_STORAGE.LS_SESSION_IS_ACTIVE);
    sessionStorage.removeItem(SESSION_STORAGE.LS_SKIP_START_BUTTON);
    window.location?.reload();
  };

  const content = (
    <>
      <div className="inactive">
        {mode && (
          <img src={SolgariLogo} alt="logo" className="inactive__logo" />
        )}
        <div className="force-reload__wrapper">
          <Paragraph>
            Are you sure you want to force reload Solgari App? Any active call
            session will stop and stored data will be
          </Paragraph>
          <div className="force-reload__buttons">
            <Button onClick={() => sendWarning('', <></>)}>No</Button>
            <Button onClick={resetLocalState}>Yes</Button>
          </div>
        </div>
      </div>
    </>
  );

  const sendWarningToParent = () => {
    sendWarning('warning', content);
  };

  switch (mode) {
    case 'show-content':
      return content;
    default:
      return (
        <>
          <Button
            className={(className || '') + ' ant-btn-icon-only ant-btn-text'}
            onClick={sendWarningToParent}
            title="Force Reload"
            data-testid="force-reload-button"
            icon={<MessageIcon svgUrl={forceReloadIcon} />}
          ></Button>
        </>
      );
  }
};
